<template>
<div>
    <v-toolbar class="pb-4">
        <!-- <v-app-bar-nav-icon /> -->

        <v-spacer />

        <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn icon>
            <v-icon>mdi-heart</v-icon>
        </v-btn>

        <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
    </v-toolbar>
</div>
</template>

<script>
export default {
  name: 'Toolbar',

  data: () => ({})
}
</script>

<style>
@font-face {
    font-family: "organo";
    src: url("../assets/Organo.ttf");
}

.center {
    margin: auto;
    width: 60%;
    padding: 10px;
}

#font {
    font-family: 'organo';
}
</style>
